module.exports = __webpack_public_path__ + "static/media/HNLOGO.8a8537ca.png";